import React from 'react';
import joinClassName from '../../utils/className.utils';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import './LoadingBlocker.scss';
var LoadingBlocker = function (props) {
    return React.createElement("div", { className: "LoadingBlocker" },
        React.createElement("div", { className: "LoadingBlockerBackdrop" }),
        React.createElement("div", { className: "LoadingBlockerInner" },
            React.createElement(LoadingIndicator, null),
            props.message && (React.createElement("div", { className: joinClassName("LoadingBlockerMessage", props.className) }, props.message))));
};
export default LoadingBlocker;
